<template>
  <div class="bxbk-container clearfix" ref="bxbk">
    <div class="mask_bg" v-if="showDesc" @click="showDesc=false"></div>
    <div class="mask_info" v-if="showDesc">
      <div class="mask_title">
        {{maskDataInfo.name}}
        <i class="iconfont icon-cha" @click="showDesc=false"></i>
      </div>
      <div class="mask_content" ref="maskContent" v-html="maskDataInfo.info"></div>
    </div>
    <div class="item" v-for="item in dataInfo" v-show="item.keyWords.length>0">
      <div class="title">{{item.text}}</div>
      <ul class="clearfix">
        <li @click="showDetail(k)" v-for="k in item.keyWords">
          <span>{{k}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
//当前实例组件
var vm = null;
export default {
  data() {
    return {
      dataInfo: [],
      maskDataInfo: {},
      showDesc: false
    };
  },
  created() {
    vm = this;
  },
  methods: {
    //文章列表数据请求
    bxbkData() {
      this.$http({
        url: "/app/insuranceBaike/api/typeList",
        type: "get",
        data: {}
      })
        .then(data => {
          vm.loaded = true;
          vm.dataInfo = data.data;
        })
        .catch(err => {
          vm.loaded = true;
        });
    },
    showDetail(keyWord) {
      this.$http({
        url: "/app/insuranceBaike/api/getInfoByKeyword",
        data: { keyWord: keyWord }
      })
        .then(data => {
          vm.loaded = true;
          vm.maskDataInfo.info = data.data;
          vm.maskDataInfo.name = keyWord;
          vm.showDesc = true;
        })
        .catch(err => {
          vm.loaded = true;
        });
    }
  },
  mounted() {
    vm.bxbkData();
    let pageHeight = this.$parent.$refs.pageHeight.clientHeight;
    this.$refs.bxbk.style.height = pageHeight - 46 - 45 + "px";
  }
};
</script>
<style lang="scss">
.bxbk-container {
  position: relative;
  padding: 0 r(20);
  padding-bottom: r(30);
  overflow: auto;
  .item {
    .title {
      font-size: r(32);
      font-weight: 900;
      padding: 0 r(20);
      padding-top: r(30);
      line-height: 1;
    }
    li {
      float: left;
      width: 33.333333%;
      text-align: center;
      margin-top: r(20);
      span {
        display: inline-block;
        width: r(210);
        line-height: r(50);
        border-radius: r(25);
        background: #f5f5f5;
        font-size: r(24);
      }
    }
  }
  .mask_bg {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1000;
    top: 0;
    left: 0;
  }
  .mask_info {
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1001;
    img {
      max-width: 100%;
    }
    .mask_title {
      line-height: r(90);
      background: #f2f2f2;
      padding: 0 r(37);
      font-size: r(32);
      position: relative;
      .icon-cha {
        width: r(90);
        text-align: center;
        display: block;
        font-size: r(32);
        position: absolute;
        top: 0;
        right: 0;
        font-size: r(38);
      }
    }
    .mask_content {
      max-height: r(800);
      overflow: auto;
      width: 100%;
      font-size: r(28) !important;
      line-height: r(45) !important;
      padding: r(20) r(37);
      text-indent: r(60);
    }
  }
}
</style>